module.exports = __webpack_public_path__ + "img/logo15px.017bce96.svg";